
import {Component, Ref, Vue} from "vue-property-decorator";

import {createOUTree} from "@/utils/tree";
import ouDetail from "./components/OuDetail.vue";
import ouEdit from "./components/ou_edit.vue";
import UserSelect from "@/components/UserSelect/index.vue";
import api from "@/api";
import {
  CreateOrganizationUnitInput,
  OrganizationUnitDto,
  OrganizationUnitLevel,
  UpdateOrganizationUnitInput,
  UserDto
} from "@/api/appService";
import ChangeStoreToNewPartialArea from "@/views/ou/components/ChangeStoreToNewPartialArea.vue";
import ChangePartialAreaToNewBigArea from "@/views/ou/components/ChangePartialAreaToNewBigArea.vue";

@Component({
  name: "ouUserManager",
  components: {ChangePartialAreaToNewBigArea, ChangeStoreToNewPartialArea, ouDetail, ouEdit, UserSelect }
})
export default class extends Vue {
  @Ref() userSelect!: UserSelect;

  @Ref() editDialog!: ouEdit;

  selectOU: any = {
    title: "Members",
    data: {}
  };
  loadingTree = true;
  level: any[] = [
    {
      label: "未分配",
      value: 0
    },
    {
      label: "总部",
      value: 1
    },
    {
      label: "大区",
      value: 2
    },
    {
      label: "片区",
      value: 4
    },
    {
      label: "门店",
      value: 8
    }
  ];
  detail: any = {};
  dialogShow = false;
  editShow = false;
  tableData: any = {
    selection: [],
    items: [],
    pagesize: 5,
    page: 1,
    sorting: "id asc",
    totalCount: 0
  };
  tableData2: any = {
    selection: [],
    items: [],
    pagesize: 10,
    page: 1,
    sorting: "uou.id desc",
    totalCount: 0
  };
  treeData: any[] = [];
  form_ou: any = {
    title: "添加机构",
    show: false,
    data: {
      displayName: "",
      parentId: undefined,
      detail: {
        logoImgUrl: "",
        desc: "",
        businessLicenseUrl: "",
        idCardBackUrl: "",
        idCardFrontUrl: ""
      }
    }
  };
  form_user: any = {
    title: "添加成员",
    show: false,
    data: {},
    rules: {}
  };
  created() {
    this.fetchData();
  }

  nodeclick(object: any, node: any, component: any) {
    // console.log(object.data);
    this.tableData2.page = 1;
    this.selectOU.data = object.data;
    if (this.selectOU.data.id) {
      this.selectOU.title = this.selectOU.data.displayName;
      this.fetchOUUsers();
    }
  }

  // 取得机构用户
  fetchOUUsers() {
    api.organizationUnit
      .getOrganizationUnitUsers({
        id: this.selectOU.data.id,
        sorting: this.tableData2.sorting,
        maxResultCount: this.tableData2.pagesize,
        skipCount: (this.tableData2.page - 1) * this.tableData2.pagesize
      })
      .then((response: any) => {
        this.tableData2.items = response.items;
        this.tableData2.totalCount = response.totalCount;
      });
  }

  fetchUsers() {
    api.user
      .getAll({
        keyword: this.form_user.keyword,
        sorting: this.tableData.sorting,
        skipCount: (this.tableData.page - 1) * this.tableData.pagesize,
        maxResultCount: this.tableData.pagesize
      })
      .then((response: any) => {
        this.tableData.items = response.items;
        this.tableData.totalCount = response.totalCount;
      });
  }

  fetchData() {
    this.loadingTree = true;
    api.organizationUnit
      .getOrganizationUnitsOfDescendantBySession({
      })
      .then(res => {
        let parentId = null;
        const ou = this.$store.getters['user/ou'] as OrganizationUnitDto;
        if(ou.level!=='总部'){
          parentId = ou.id;
        }

        const tree = createOUTree(
          res,
          "parentId",
          "id",
          parentId,
          "children",
          ""
        );
        console.log(tree);
        this.treeData = tree;
        this.loadingTree = false;
      });
  }
  async handleEdit_ou() {
    await api.organizationUnit
      .getForEdit({ id: this.selectOU.data.id })
      .then(res => {
        (this.$refs.editDialog as any).show = true;
        this.detail = res.data;
        this.level = (res.schema as any).level;
      });
  }
  async handleView_ou() {
    await api.organizationUnit
      .getOrganizationUnit({ id: this.selectOU.data.id })
      .then(res => {
        (this.$refs.detailDialog as any).show = true;
        this.detail = res;
      });
  }
  handle_activeOrUnActive(){
    let isActive = this.selectOU.data.isActive as boolean;
    let orgId = this.selectOU.data.id as number;
    let promise ;
    if(isActive){
      promise = api.organizationUnit.unActive({body:{id:orgId}})
    } else {
      promise = api.organizationUnit.active({body:{id:orgId}})
    }
    promise.then(res=>{
      this.selectOU.data.isActive = !isActive;
      if(isActive){
        this.$message.warning('机构已被禁用')
      } else {
        this.$message.success( '机构已被启用');
      }
    })

  }

  async handleDelete_ou_user() {
    console.log("selection", this.tableData2.selection);
    console.log("selectou", this.selectOU.data);
    const userIds: number[] = [];
    const organizationUnitId = this.selectOU.data.id;
    await this.$confirm("您确认要删除此用户吗?", "删除提示").then(
      () => {
        this.tableData2.selection.forEach((x: any) => {
          userIds.push(x.id as number);
        });
        api.organizationUnit
          .removeUsersFromOrganizationUnit({
            body: { userIds, organizationUnitId }
          })
          .then(res => {
            this.fetchOUUsers();
          });
      },
      cancel => {
        console.log("cancel delete ou user");
      }
    );
  }
  // handle_user start

  handleAdd_user() {
    this.userSelect.show = true;
  }
  onSelect(e: UserDto[]) {
    console.log(e);
    console.log(this.selectOU!);
    if (this.selectOU!.data.id) {
      api.organizationUnit
        .addUsersToOrganizationUnit({
          body: {
            userIds: e.map(x => x.id!),
            organizationUnitId: this.selectOU!.data.id as number
          }
        })
        .then(res => {
          console.log(res);
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.form_user.show = false;
          this.fetchOUUsers();
          this.fetchData();
        });
    }
  }
  // handle_user end

  handleSelectionChange2(e: any) {
    // 机构用户选中
    console.log(e);
    this.tableData2.selection = e;
  }
  sort(e: any) {
    console.log("sort : ", e);
    if (e.prop === "userName") e.prop = `user.UserName`;
    if (e.prop === "id") e.prop = `uou.id`;
    if (e.prop === "phoneNumber") e.prop = `user.PhoneNumber`;
    if (e.prop && e.order) {
      this.tableData2.sorting = `${e.prop} ${e.order}`;
    } else {
      this.tableData2.sorting = "uou.id desc";
    }
    this.fetchOUUsers();
  }

  handleAdd_ou(parentNode: any = null) {
    debugger
    console.log(parentNode);
    const ou = this.$store.getters['user/ou'] as OrganizationUnitDto;
    if(!parentNode.id){
      if(ou.level!=='总部'){
        parentNode = {
          id:ou.id,
          level:ou.level
        }
      }
    }

    this.detail = {
      parentId: (parentNode?.id??undefined),
      displayName: "",
      level:OrganizationUnitLevel.大区,
      detail: {
        logoImgUrl: "",
        desc: "",
        idCardFrontUrl: "",
        idCardBackUrl: "",
        businessLicenseUrl: ""
      }
    } as UpdateOrganizationUnitInput | CreateOrganizationUnitInput;
    if(parentNode.id){
      this.detail.level = this.getSubLevel(parentNode.level);
    } else {
      this.detail.level = OrganizationUnitLevel.大区; // 大区
    }
    if(this.detail.level === OrganizationUnitLevel.门店){
      this.detail.isLeaf = true; // 如果级别是个门店，将isLeaf设为true
    }


    (this.editDialog as any).show = true;
  }
  getSubLevel(level:number | OrganizationUnitLevel){
    const levelMapping = [{
      label: OrganizationUnitLevel.总部,
      value: 1
    },
      {
        label: OrganizationUnitLevel.大区,
        value: 2
      },
      {
        label: OrganizationUnitLevel.片区,
        value: 4
      },
      {
        label: OrganizationUnitLevel.门店,
        value: 8
      }];
    for(let i = 0;i<levelMapping.length;i++){
      if(levelMapping[i].label === level){
        return levelMapping[i+1].label;
      }
    }
    return 2;
  }
  append(data: any) {
    console.log("append", data);
    if (data.data.isLeaf) this.$message.error("门店不能再添加子机构了");
    else this.handleAdd_ou(data.data);
  }
  remove(node: any, data: any) {
    console.log("delete", node, data);
    this.$confirm(
      "您确认要删除此角色吗?如果存在子机构,将全部一起删除",
      "删除提示"
    ).then(
      () => {
        api.organizationUnit.deleteOrganizationUnit({id:data.id}).then(res => {
          // console.log(res);
          this.$message({ type: "success", message: "删除成功" });
          this.fetchData();
        });
      },
      cancel => {
        console.log("cancel");
      }
    );
  }
  // user table
  current_change(e: any) {
    this.tableData.page = e;
    this.fetchUsers();
  }
  handleSizeChange(e: any) {
    this.tableData.pagesize = e;
    this.fetchUsers();
  }
  handleChangeStoreToNewPartialArea(){
    (this.$refs.changeStoreToNewPartialArea as any).storeId = this.selectOU.data.id;
    (this.$refs.changeStoreToNewPartialArea as any).show = true;
  }
  handleStoreChangeCompleted(){
    this.fetchData();
  }

  handleChangePartialAreaToNewPartialArea(){
    debugger;
    (this.$refs.changePartialAreaToNewBigArea as any).partialAreaId = this.selectOU.data.id;
    (this.$refs.changePartialAreaToNewBigArea as any).show = true;
  }

  handlePartialAreaChangeCompleted(){
    this.fetchData();
  }
}
